export default "__VITE_ASSET__DV1QPwpd__"